import { Component, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { IChatConversation, INewConversationData, IOpenConversationManageUsersData } from '@fi-shared/fi-chat/fi-chat';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiChatService } from '@fi-shared/fi-chat/fi-chat.service';
import { FiChatConversationType } from '@fi-shared/fi-chat/fi-chat-conversation-type';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { ManageUsersStep } from '@fi-shared/fi-chat/fi-chat-conversation-manage-type';

@Component({
    selector: 'fi-chat-conversation-settings-menu',
    templateUrl: './fi-chat-conversation-settings-menu.component.html',
    styleUrls: ['./fi-chat-conversation-settings-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-settings-menu' },
    standalone: false,
})
export class FiChatConversationSettingsMenuComponent {
    @Input() conversation: IChatConversation;
    @Input() isNewConversation: boolean;
    @Input() managingUsersMode: boolean;
    @Output() onCloseConversation = new EventEmitter();
    @Output() managingUsersModeChange = new EventEmitter<IOpenConversationManageUsersData>();
    @Output() onStartNewConversation = new EventEmitter<INewConversationData>();
    manageUsersStep = ManageUsersStep;

    constructor(
        private fiChatHelperService: FiChatHelperService,
        private appTextService: AppTextService,
        private fiChatService: FiChatService,
        private detectDeviceService: DetectDevicesService,
    ) {}

    getMenuIconClassName(): string {
        return this.isPersonalChat() ? 'fas fa-user-cog' : 'fas fa-users-cog';
    }

    isPersonalChat(): boolean {
        return this.fiChatHelperService.isPersonalChat(this.conversation);
    }

    isMobileScreen(): boolean {
        return this.detectDeviceService.isMobilePhone();
    }

    isConversationHidden(): boolean {
        return this.conversation.IsHidden;
    }

    openRemoveConversationConfirmDialog() {
        this.fiChatHelperService.openRemoveConversationDialog().then(() => {
            this.updateConversationIsHidden(true);
            this.closeConversation();
        });
    }

    changeConversationName() {
        this.fiChatHelperService
            .openRenameConversationDialog(this.conversation)
            .then((result) => this.fiChatService.changeConversationName(this.conversation.Id, result));
    }

    private updateConversationIsHidden(newIsHidden: boolean) {
        this.fiChatService.updateConversationIsHidden(this.conversation.Id, newIsHidden);
    }

    closeConversation() {
        this.onCloseConversation.emit();
    }

    setManagingUsersMode(status: boolean, currentStep?: ManageUsersStep) {
        this.managingUsersModeChange.emit({ status, currentStep });
    }

    openLeaveGroupConversationDialog() {
        this.fiChatHelperService.openLeaveGroupConversationDialog().then(() => this.leaveConversation());
    }

    private leaveConversation() {
        this.fiChatService.leaveConversation(this.conversation.Id).then(() => this.closeConversation());
    }

    startNewConversation() {
        this.onStartNewConversation.emit({
            type: FiChatConversationType.Group,
            selectedUserIds: this.conversation.Users.map((u) => u.Id),
            message: undefined,
        });
    }
}
